import { HUD } from '../HUD'

import { useFlow } from '@/shared/lib/steps-flow'

import { LevelFooterRightAnswerAlert } from './RightAnswerAlert'
import { LevelFooterWrongAnswerAlert } from './WrongAnswerAlert'

export const LevelFooter = ({ children }) => {
  const { state, goNext, retryChallenge } = useFlow()

  return (
    <HUD.Footer>
      <div className="flex items-center justify-between gap-4 relative z-1 w-full">
        {children}
      </div>
      <LevelFooterRightAnswerAlert />
      <LevelFooterWrongAnswerAlert />
    </HUD.Footer>
  )
}
